import postscribe from 'postscribe'

export const gtag = (gtag) => {
  const script = `
  <!-- Global site tag (gtag.js) - Google Analytics -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${gtag}"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gtag}');
  </script>
  `
  return new Promise((resolve, reject) => {
    const element = document.getElementById('marketing')
    const callback = {
      done: function () {
        resolve()
      },
      error: function (response) {
        // Callback para chamadas que falharam.
        reject(response)
      }
    }
    postscribe(element, script, callback)
  })
}
export const pixel = (pixelId) => {
  const script = `
  <!-- Facebook Pixel Code -->
  <script>
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${pixelId}');
  fbq('track', 'PageView');
  </script>
  <noscript><img height="1" width="1" style="display:none"
  src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"
  /></noscript>
  <!-- End Facebook Pixel Code -->
  `
  return new Promise((resolve, reject) => {
    const element = document.getElementById('marketing')
    const callback = {
      done: function () {
        resolve()
      },
      error: function (response) {
        // Callback para chamadas que falharam.
        reject(response)
      }
    }
    postscribe(element, script, callback)
  })
}
